import { TIdToPageMap } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsule61 } from './pages'

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE_61: TIdToPageMap = {
  [PageIdStylioCapsule61.SUBSCRIPTIONS_CAPSULE_61]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_61/pages/CapsuleSubscriptionPage'
      ).then((m) => ({
        default: m.CapsuleSubscriptionPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_61/pages/CapsuleSubscriptionPage'),
  },
  [PageIdStylioCapsule61.SUB_UPSELL_CAPSULE_61]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_61/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_61/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsule61.FACE_STYLING_PDF_UPSELL_CAPSULE_61]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_61/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_61/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioCapsule61.PROPORTIONS_PDF_UPSELL_CAPSULE_61]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_61/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_61/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioCapsule61.DOWNLOAD_CAPSULE_61]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_61/pages/download-capsule/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_61/pages/download-capsule/DownloadDefault'
      ),
  },
}
